import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import {
  Button, Checkbox, Modal, Segment, Table,
} from 'semantic-ui-react';

import RowActionMenu from './RowActionMenu';
import {
  ACTIVATE_COVERAGE_NOTICE,
  BATCH_DETAILS_DIALOG_HEADER,
  DIALOG_CLOSE_LABEL,
  QUEUE_STATUS,
  QUEUE_VIEW,
  VALUE_PLACEHOLDER,
} from '../../constants/onboardingQueue';
import {
  coverageStartDate,
  hasAgreedPrice,
  priceProps,
  statusLabel,
} from '../../utilities/onboardingQueue';

const fieldValue = value => (value == null || value === '' ? VALUE_PLACEHOLDER : value);

const BatchDetailsDialog = ({
  view, dealers, onClose, onDealerAction,
}) => (
  <Modal
    open
    size='large'
    onClose={onClose}
    closeOnDimmerClick={false}
    data-testid='queue-batch-details-dialog'
  >
    <Modal.Header>{BATCH_DETAILS_DIALOG_HEADER}</Modal.Header>
    <Modal.Content>
      <Segment data-testid='queue-batch-details-summary'>
        <div>
          <b>Product:</b>
          {' '}
          <span data-testid='queue-batch-details-product'>{fieldValue(dealers[0].productType)}</span>
        </div>
        <div>
          <b>{ACTIVATE_COVERAGE_NOTICE}</b>
          {' '}
          <span data-testid='queue-batch-details-coverage-date'>{coverageStartDate()}</span>
        </div>

        <Table compact celled data-testid='queue-batch-details-table'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell collapsing />
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Customer ID</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell collapsing />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {dealers.map(dealer => (
              <Table.Row key={dealer.flatRateOfferId} data-testid='queue-batch-details-row'>
                <Table.Cell collapsing>
                  <Checkbox
                    checked={dealer.status === QUEUE_STATUS.ACCEPTED}
                    disabled
                    aria-label={fieldValue(dealer.dealerName)}
                    data-testid='queue-batch-details-checkbox'
                  />
                </Table.Cell>
                <Table.Cell data-testid='queue-batch-details-customer'>
                  {fieldValue(dealer.dealerName)}
                </Table.Cell>
                <Table.Cell data-testid='queue-batch-details-customer-id'>
                  {fieldValue(dealer.customerId)}
                </Table.Cell>
                <Table.Cell data-testid='queue-batch-details-price'>
                  {hasAgreedPrice(dealer.subscriptionPrice)
                    ? React.createElement(FormattedNumber, priceProps(dealer.subscriptionPrice))
                    : VALUE_PLACEHOLDER}
                </Table.Cell>
                <Table.Cell data-testid='queue-batch-details-status'>
                  {statusLabel(dealer.status)}
                </Table.Cell>
                <Table.Cell collapsing>
                  <RowActionMenu
                    view={view}
                    row={{ flatRateOfferBatchId: dealer.flatRateOfferBatchId, dealers: [dealer] }}
                    onAction={onDealerAction}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose} data-testid='queue-batch-details-close'>
        {DIALOG_CLOSE_LABEL}
      </Button>
    </Modal.Actions>
  </Modal>
);

BatchDetailsDialog.propTypes = {
  view: PropTypes.oneOf(Object.values(QUEUE_VIEW)).isRequired,
  dealers: PropTypes.arrayOf(PropTypes.shape({
    flatRateOfferId: PropTypes.string,
    flatRateOfferBatchId: PropTypes.string,
    dealerName: PropTypes.string,
    customerId: PropTypes.string,
    productType: PropTypes.string,
    subscriptionPrice: PropTypes.number,
    status: PropTypes.string,
  })).isRequired,
  onClose: PropTypes.func.isRequired,
  onDealerAction: PropTypes.func.isRequired,
};

export default BatchDetailsDialog;
